var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column" }, [
    _vm.activeSearchBar
      ? _c("div", { staticClass: "form-group mb-2 p-0 fs-3" }, [
          _c("div", { staticClass: "form-input wp-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchKeyword,
                  expression: "searchKeyword"
                }
              ],
              ref: "searchfilter",
              staticClass: "h-4 wp-10",
              attrs: { type: "text", placeholder: _vm.searchPlaceholder },
              domProps: { value: _vm.searchKeyword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchKeyword = $event.target.value
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "big-item-list bb-1" },
      [
        !!_vm.options.length
          ? _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.allselected,
                    expression: "allselected"
                  }
                ],
                attrs: {
                  id: "checkUncheck",
                  type: "checkbox",
                  name: "checkUncheck"
                },
                domProps: {
                  checked: Array.isArray(_vm.allselected)
                    ? _vm._i(_vm.allselected, null) > -1
                    : _vm.allselected
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.allselected,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.allselected = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.allselected = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.allselected = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "checkUncheck" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.choices.length === Object.values(_vm.options).length
                        ? _vm.$l10n.__("Tout décocher")
                        : _vm.$l10n.__("Tout cocher")
                    ) +
                    "\n            "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.options, function(option) {
          return [
            _c(
              "div",
              { key: option.value, staticClass: "form-group" },
              [
                _c(
                  "label",
                  {
                    staticClass: "form-label label-auto",
                    attrs: { for: "opt-" + option.value }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.choices,
                          expression: "choices"
                        }
                      ],
                      attrs: {
                        id: "opt-" + option.value,
                        type: "checkbox",
                        name: "options[]"
                      },
                      domProps: {
                        value: "" + option.value,
                        checked: Array.isArray(_vm.choices)
                          ? _vm._i(_vm.choices, "" + option.value) > -1
                          : _vm.choices
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.choices,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "" + option.value,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.choices = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.choices = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.choices = $$c
                            }
                          },
                          function($event) {
                            return _vm.handleCheckedOption(
                              $event.target.checked,
                              option.options
                            )
                          }
                        ]
                      }
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(option.label) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.orderOptionsByRank(option.options), function(
                  subOption
                ) {
                  return [
                    _c(
                      "div",
                      { key: subOption.value, staticClass: "form-group ml-4" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label label-auto",
                            attrs: { for: "subopt-" + subOption.value }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.subChoices,
                                  expression: "subChoices"
                                }
                              ],
                              attrs: {
                                id: "subopt-" + subOption.value,
                                type: "checkbox",
                                name: "subOption[]"
                              },
                              domProps: {
                                value: subOption.value,
                                checked: Array.isArray(_vm.subChoices)
                                  ? _vm._i(_vm.subChoices, subOption.value) > -1
                                  : _vm.subChoices
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.subChoices,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = subOption.value,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.subChoices = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.subChoices = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.subChoices = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.handleCheckedSubOption(
                                      "" + option.value
                                    )
                                  }
                                ]
                              }
                            }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(subOption.label) +
                                "\n                        "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }